var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbIconb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.971,
    height: 31.789,
    viewBox: "0 0 31.971 31.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9351",
    "data-name": "Group 9351",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "facebook-outline-svgrepo-com",
    d: "M31.971,16.986a14.986,14.986,0,1,0-17.327,14.8V21.317h-3.8V16.986h3.8v-3.3c0-3.756,2.237-5.83,5.66-5.83a23.046,23.046,0,0,1,3.355.293v3.688h-1.89a2.166,2.166,0,0,0-2.442,2.34v2.811h4.156l-.664,4.332H19.327V31.789A14.989,14.989,0,0,0,31.971,16.986Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#111",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIconb);
export default __webpack_public_path__ + "static/media/fb-iconb.3c76087a439fab7d4161acc641acc786.svg";
export { ForwardRef as ReactComponent };